import { render, staticRenderFns } from "./ClientsToBooker.vue?vue&type=template&id=1366741b"
import script from "./ClientsToBooker.vue?vue&type=script&lang=js"
export * from "./ClientsToBooker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports